import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth, connectAuthEmulator } from 'firebase/auth';
import { devLog } from '../utils/dev-log';

// Admin tenant ID for multi-tenant authentication (per-environment via Vite env)
export const ADMIN_TENANT_ID = import.meta.env.VITE_ADMIN_TENANT_ID || 'lasoxp-agent-admin-wrtld';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
};

// Initialize Firebase
export const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize services with admin tenant
export const auth: Auth = getAuth(app);
// Firebase Auth emulator doesn't support multi-tenant auth — skip tenantId in emulator mode
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR !== 'true') {
  auth.tenantId = ADMIN_TENANT_ID;
}


// Connect auth emulator in development (Firestore emulator is handled in lib/firestore.ts)
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === 'true') {
  connectAuthEmulator(auth, 'http://localhost:9098');
}

devLog(`Using admin tenant: ${ADMIN_TENANT_ID}`);
